import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/styles/index.scss';
import "tailwindcss/tailwind.css"
import './permission' // permission control
import Echart from './components/echart/index.vue'

import { parseTime, resetForm, addDateRange, selectDictLabel, selectDictLabels, handleTree } from "@/utils/ruoyi";
// 字典标签组件
import DictTag from '@/components/DictTag'
// 字典数据组件
import RightToolbar from "@/components/RightToolbar"
// 分页组件
import Pagination from "@/components/Pagination";
import directive from './directive' // directive
import plugins from './plugins' // plugins
import '@/icons/index.js'
//大屏框架
import dataV from '@jiaminghi/data-view'

// 全局方法挂载
Vue.prototype.parseTime = parseTime
Vue.prototype.resetForm = resetForm
Vue.prototype.addDateRange = addDateRange
Vue.prototype.selectDictLabel = selectDictLabel
Vue.prototype.selectDictLabels = selectDictLabels
Vue.prototype.handleTree = handleTree

// 全局组件挂载
Vue.component('DictTag', DictTag)
Vue.component('RightToolbar', RightToolbar)
Vue.component('Pagination', Pagination)
Vue.component("Echart",Echart)

Vue.use(directive)
Vue.use(plugins)
Vue.use(ElementUI);
Vue.use(dataV)


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
